var text = '_1qq6l4j0';

export { text };
//# sourceMappingURL=inputs.hooks.css.js.map
